import { useOnboarding } from '../hooks/useOnboarding'
import { track } from '../umami'

export default function WelcomeBanner() {
  const { isOnboarded, dismissOnboarding } = useOnboarding()

  if (isOnboarded) return null

  const handleDismiss = () => {
    dismissOnboarding()
    track('onboarding_dismissed')
  }

  return (
    <div id="welcome-banner" role="region" aria-label="Welcome to ArcheoMap">
      <div className="welcome-banner-content">
        <h2>Welcome to ArcheoMap</h2>
        <ul>
          <li>
            <span className="welcome-bullet" aria-hidden="true">
              📍
            </span>
            Explore thousands of archaeological sites around the world
          </li>
          <li>
            <span className="welcome-bullet" aria-hidden="true">
              ✨
            </span>
            Click any marker to read an AI-generated narrative about the site
          </li>
          <li>
            <span className="welcome-bullet" aria-hidden="true">
              🔴
            </span>
            Red circles mark conflict-affected areas and damaged heritage
          </li>
        </ul>
      </div>
      <button
        className="welcome-banner-close"
        aria-label="Dismiss welcome banner"
        onClick={handleDismiss}
      >
        Got it
      </button>
    </div>
  )
}
